// src/App.js

import React from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/auth/Login';
import OrdersTable from './components/orders/OrdersTable';
import { Button } from './components/ui/button';

// Main App Component with Auth Check
const AppContent = () => {
  const { isAuthenticated, isLoading, logout } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center p-4">
          <div className="text-lg text-gray-600">Loading...</div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Navbar */}
      <nav className="bg-white shadow mb-4">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-900">
            Orders
          </h1>
          <Button 
            onClick={logout} 
            variant="outline"
            className="hover:bg-gray-100"
          >
            Logout
          </Button>
        </div>
      </nav>

      {/* Main Content */}
      <main>
        <OrdersTable />
      </main>
    </div>
  );
};

// Root App Component with Providers
const App = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;